
import { distinctUntilChanged, switchMap, map } from 'rxjs/operators';
import { Injectable } from '@angular/core';
import {Observable, combineLatest, BehaviorSubject} from 'rxjs';
import { CmsAlarms } from 'app/models/monitor/cms-alarms.model';
import { CmsAlarmsPortfolioGQL, CmsAlarmsParkGQL, CmsAlarmsTurbineGQL, CmsAlarmsPortfolioCustomGQL, CmsAlarmsPortfolioReportGQL, CmsAlarmsParkReportGQL } from '../../graphql';
import {NavigationDetails} from '../../navigation/navigation.service';

@Injectable({
  providedIn: 'root',
})
export class CmsAlarmsService {

  constructor(
    private cmsAlarmsPortfolio: CmsAlarmsPortfolioGQL,
    private cmsAlarmsPortfolioReport: CmsAlarmsPortfolioReportGQL,
    private cmsAlarmsPark: CmsAlarmsParkGQL,
    private cmsAlarmsParkReport: CmsAlarmsParkReportGQL,
    private cmsAlarmsTurbine: CmsAlarmsTurbineGQL,
    private cmsAlarmsPortfolioCustom: CmsAlarmsPortfolioCustomGQL
  ) { }

  public getCmsAlarmsPortfolioDataCustom(showAllObservable: Observable<boolean>, navigationDetails: NavigationDetails): Observable<CmsAlarms> {
    return showAllObservable.pipe(
      distinctUntilChanged(),
      switchMap((showAll) =>{
        const parameters = showAll ? { showAll, hours: 24, portfolioId: navigationDetails.selectedPortfolioId, parkIds: navigationDetails.selectedParksIds } :
        { showAll, portfolioId: navigationDetails.selectedPortfolioId, parkIds: navigationDetails.selectedParksIds };
        return this.cmsAlarmsPortfolioCustom.subscribe({ variables: parameters}).pipe(
          map(result => CmsAlarms.mapPortfolio(result.data.portfolios[0]))
        )
     })
    );
  }

  public getCmsAlarmsPortfolioData(showAllObservable: Observable<boolean>): Observable<CmsAlarms> {
    return showAllObservable.pipe(
      distinctUntilChanged(),
      switchMap((showAll: boolean) =>
        this.cmsAlarmsPortfolio.subscribe({
          variables:{showAll}
        }).pipe(
          map(result => CmsAlarms.mapPortfolio(result.data.portfolios[0]))
        )
      )
    );
  }
  public getCmsAlarmsParkData(parkNameObservable: Observable<string>,
                              showAllObservable: Observable<boolean>,
                              selectedTurbinesIds: string[]): Observable<CmsAlarms> {
    return combineLatest([
      showAllObservable,
      parkNameObservable
    ]).pipe(
      distinctUntilChanged(),
      switchMap(([showAll, parkName]) =>{
        const parameters = showAll ? { name: parkName, showAll, hours: 24, turbineIds: selectedTurbinesIds } :
        { name: parkName, showAll, turbineIds: selectedTurbinesIds };
        return this.cmsAlarmsPark.subscribe({
          variables: parameters
        }).pipe(
          map(result => CmsAlarms.mapPark(result.data.parks[0]))
        )
      })
    );
  }

  public getCmsAlarmsTurbineData(turbineSerialObservable: Observable<number>, showAllObservable: Observable<boolean>): Observable<CmsAlarms> {
    return combineLatest([
      showAllObservable,
      turbineSerialObservable
    ]).pipe(
      distinctUntilChanged(),
      switchMap(([showAll, turbineSerial]) =>{
        const parameters = showAll ? { showAll, hours: 24, serialNav: turbineSerial } :
        { showAll, serialNav: turbineSerial };
        return this.cmsAlarmsTurbine.subscribe({ variables: parameters }).pipe(
          map(result => CmsAlarms.mapTurbine(result.data.turbines[0]))
        )
      })
    );
  }
  public getCmsAlarmsPortfolioReportData(showAllObservable: Observable<boolean>, startTS: number, endTS: number, portfolioId: string): Observable<CmsAlarms> {
    return showAllObservable.pipe(
      distinctUntilChanged(),
      switchMap((showAll: boolean) =>
        this.cmsAlarmsPortfolioReport.fetch({
          variables: {
          showAll,
          startTS,
          endTS,
          portfolioId}
        }).pipe(
          map(result => CmsAlarms.mapPortfolio(result.data.portfolios[0]))
        )
      )
    );
  }
  public getCmsAlarmsParkReportData(parkNameObservable: Observable<string>, showAllObservable: Observable<boolean>, startTS: number, endTS: number, turbines: string[]): Observable<CmsAlarms> {
    return combineLatest([
      showAllObservable,
      parkNameObservable
    ]).pipe(
      distinctUntilChanged(),
      switchMap(([showAll, parkName]) =>
        this.cmsAlarmsParkReport.fetch({
          variables: {
          name: parkName,
          showAll,
          startTS,
          endTS,
          turbineIds: turbines }
        }).pipe(
          map(result => CmsAlarms.mapPark(result.data.parks[0]))
          )
        )
      );
    }
}
